export class ModalData {
  constructor(
    public readonly title: string,
    public readonly description: string,
    public readonly cancel: boolean = true,
    public readonly crossIcon: boolean = true,
  ) {
  }
}
